import { ApplicationDataStore } from '@servicetitan/financing-application-shared';
import { StepperLayout } from '../layout';
import {
    SignatureButtons,
    SignatureStep,
    DecisionResultButtons,
    DecisionResultStep,
    EsignStep,
    EsignButtons,
} from '../steps';
import { WorkflowStore } from '@servicetitan/financing-workflow-shared';
import { ErrorBoundary } from '@servicetitan/financing-utils-shared';

export enum DecisionSteps {
    decision = 0,
    esign = 1,
    signature = 2,
}

export const DecisionWorkflow = () => {
    const { applicationData } = ApplicationDataStore.useStore();
    const { setWorkflowStage } = WorkflowStore.useStore();
    const hasCoApplicant = applicationData?.coApplicant?.hasCoApplicant ?? false;

    return (
        <StepperLayout
            onComplete={() => setWorkflowStage('signing')}
            steps={[
                {
                    name: 'decision',
                    label: 'Decision',
                    panelComponent: <DecisionResultStep />,
                    buttonsComponent: <DecisionResultButtons />,
                },
                {
                    name: 'esign',
                    label: 'E-sign Agreement',
                    panelComponent: <EsignStep hasCoApplicant={hasCoApplicant} />,
                    buttonsComponent: <EsignButtons />,
                },
                {
                    name: 'signature',
                    label: 'Signature',
                    panelComponent: (
                        <ErrorBoundary actionCausingError="generating loan documents">
                            <SignatureStep />
                        </ErrorBoundary>
                    ),
                    buttonsComponent: <SignatureButtons />,
                    largeFooter: true,
                },
            ]}
        />
    );
};
